import { useState } from "react";
import { HardHat, Phone } from "lucide-react";
import { toast } from "sonner";
import { techApi, techErr, TECH_TOKEN_KEY } from "../../lib/teknisiApi";

export default function TeknisiLogin({ onLogin }) {
  const [wa, setWa] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await techApi.post("/auth/login", { wa });
      localStorage.setItem(TECH_TOKEN_KEY, data.token);
      toast.success(`Selamat datang, ${data.tech.name}`);
      onLogin(data.tech);
    } catch (err) { toast.error(techErr(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0f2a6b] flex items-center justify-center p-4" data-testid="teknisi-login">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl p-6 space-y-4 shadow-2xl">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-[#F04E23] flex items-center justify-center"><HardHat className="w-7 h-7 text-white" /></div>
          <div><div className="font-extrabold text-lg text-[#0f2a6b]">Portal Teknisi</div><div className="text-xs text-slate-500">Fasnet Fiber · Laporan kerja & absensi</div></div>
        </div>
        <label className="block space-y-1">
          <span className="text-sm font-semibold text-slate-700">Nomor WhatsApp</span>
          <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-3 h-12 focus-within:border-[#0f2a6b]">
            <Phone className="w-4 h-4 text-slate-400" />
            <input value={wa} onChange={(e) => setWa(e.target.value)} inputMode="tel" placeholder="08xxxxxxxxxx" required className="flex-1 outline-none text-base" data-testid="teknisi-login-wa" />
          </div>
        </label>
        <button type="submit" disabled={busy} className="w-full h-12 rounded-xl bg-[#0f2a6b] text-white font-bold disabled:opacity-60" data-testid="teknisi-login-submit">{busy ? "Memeriksa…" : "Masuk"}</button>
        <p className="text-[11px] text-slate-500 text-center">Hanya nomor WA teknisi yang terdaftar oleh admin Fasnet yang dapat masuk.</p>
      </form>
    </div>
  );
}
